export const ORDER_FETCH = 'orders.ORDER_FETCH';
export const ORDER_FETCH_REORDER = 'orders.ORDER_FETCH_REORDER';
export const ORDER_CREATED = 'orders.ORDER_CREATED';
export const ORDER_START_FETCH = 'orders.ORDER_START_FETCH';
export const ORDER_END_FETCH = 'orders.ORDER_END_FETCH';


// WEBPACK FOOTER //
// ./src/types/order.js